export default {"src":"/_next/static/media/RelysiaLogo_1.4aba7d51.svg","height":345,"width":326};